import {getToken, onMessage} from "firebase/messaging";
import {messaging} from "../firebase";

// Web push key belongs to the Firebase project; staging builds set their own.
const VAPID_KEY = process.env.REACT_APP_FIREBASE_PROJECT_ID
    ? process.env.REACT_APP_FIREBASE_VAPID_KEY
    : "BDOGBKjjpbWoidI3ZmclYotJ1M0GYGn7Bj4P80ntwJMLCR1ILDdW8bh8Y-33FY5rrKMf4pBD1QbpOGd5oVB2Yk4";

export {getToken, messaging, onMessage, VAPID_KEY};
